import moment from "moment";
import * as Output from '../../Text';
import {money} from "./money";
import {merge, Rules} from "../technical";

const validateCreditMonthlyRate = merge(Rules.required, money);


const validateCreditBegin = merge(Rules.required, (value) => {

  const date = moment(value, 'YYYY-MM-DD', true);;

  if (!date.isValid()) {
    return Output.resolve('generic.errors.M004a_dateFormat');
  }

  if (date.isAfter(moment(), 'date')) {
    return Output.resolve(
        'generic.errors.M004b_dateCanNotBeInTheFuture',
    );
  }

  if (date.isBefore(moment().subtract(50, 'years'))) {
    return Output.resolve('generic.errors.M005b');
  }

  return undefined;
});

const validateCreditTerm = (value) => {

  if (!value) {
    return Output.resolve('generic.errors.M001_mandatoryFields');
  }

  if (!/^(?!0)\d*$/.test(value)) {
    return Output.resolve('generic.errors.M002_invalidCharacters');
  }

  return Rules.minLength(1)(value) || Rules.maxLength(3)(value);
};

const validateCredit = (credit) => {

  const error = {
    creditType: Rules.required(credit.creditType),
    creditMonthlyRate: validateCreditMonthlyRate(credit.creditMonthlyRate)
  };

  if (['CONSUMER_CREDIT', 'LEASING'].includes(credit.creditType)) {

    error.creditBegin = validateCreditBegin(credit.creditBegin);
    error.creditTerm = validateCreditTerm(credit.creditTerm)
  }

  return error;
};

const validateCredits = (credits, allValues) => {

  if (allValues.activeCreditContracts !== 'yes') {
    return undefined;
  }

  if (!(Array.isArray(credits) && credits.length)) {
    return Output.resolve('generic.errors.M001_mandatoryFields');
  }

  const result = credits.map(validateCredit);

  const hasValues = obj => !!(Object.keys(obj).find(key => !!obj[key]));
  return result.some(hasValues) ? result : undefined;
};

export {validateCredits};